import React,{useEffect , useState} from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import api from "../../../api/api";

const ImpLinkUpdate = ({LinkId,setDeleteResp}) => {

  const { register, handleSubmit,setValue } = useForm();
  const [linkList, setLinkList] = useState({});
  const [changes, setChanges] = useState(false)

  useEffect(() => {
    api.get(`/info/important-links/?id=${LinkId}`)
    .then(res=> {
      // console.log("data",res.data[0])
      // setBookmarkData(res.data[0])
      setLinkList(res.data[0])

    }).catch(err=> {
      console.log(err)
    })
  }, [LinkId,changes])


  const handleSub = (data)=> {
    console.log(data)
    api.patch(`/info/important-links/${LinkId}/`,data)
    .then(response=> {
      setDeleteResp(true)
      setChanges(true)

      toast.success("Important link registered")
    }).catch(error=> {
      toast.error("Something went wrong")
    })
  }

  return (
    <form className="" onSubmit={handleSubmit(handleSub)}>
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Update Important Link
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* table  */}
      <div className="mt-5 px-3 md:!px-10">
        <div className="border">
          <div className="grid md:grid-cols-2">
            {/* Link Name */}
            <div className="flex items-center gap-2 border-2 border-gray-900 p-2">
              <label htmlFor="" className="text-primary-red">
                Link Name:
              </label>
              <input
                type="text"
                // name=""
                {...register("title", { required: false }, setValue("title", linkList.title))}

                className="flex-grow py-2 px-2 outline-none"
                id="nepali-datepicker"
                placeholder="Link Name"
              />
            </div>
            {/* Link category */}
            <div className="flex items-center gap-2 border-2 border-t-0 border-black p-2 md:!border-t-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                Link category:
              </label>
              <input
                type="text"
                // name=""
                {...register("category", { required: false }, setValue("category", linkList.category) )}
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Link category"
              />
            </div>
            {/* Link details */}
            <div className="flex items-center gap-2 border-2 border-t-0 border-black p-2">
              <label htmlFor="" className="text-primary-red">
                Link details:
              </label>
              <input
                type="text"
                // name=""
                {...register("details", { required: false }, setValue("details",linkList.details))}
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Link Details"
              />
            </div>
            {/* Link Address */}
            <div className="flex items-center gap-2 border-2 border-t-0 border-black p-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                Link Address:
              </label>
              <input
                type="text"
                // name=""
                {...register("link", { required: false }, setValue("link", linkList.link))}
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Link Address"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end mt-2">
        <button className="bg-red-600 py-2 px-3 rounded-xl text-white font-bold">Submit</button>
      </div>
      </div>
      {/* end table */}

     
    </form>
  );
};

export default ImpLinkUpdate;
